<template>
<div>
    <header class="header">
        <!--start navbar-->
        <nav class="navbar navbar-expand-lg fixed-top custom-nav white-bg">
            <div class="container">
                <div class="collapse navbar-collapse main-menu" id="navbarSupportedContent">
                </div>
            </div>
        </nav>
        <!--end navbar-->
    </header>
    <div class="main">

        <!--hero section start-->
        <section class="hero-section hero-section-3 my-5">
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <div class="col-md-6 col-lg-6">
                        <div class="hero-content-left mb-5 pt-0">
                            <a class="navbar-brand" href="https://denuncias.serpar.gob.pe/">
                                <img alt="logo" class="img-fluid" :src="'./static/img/serpar-default.png'" width="120"></a>
                            <h1><span>Sistema de Denuncias</span> por actos de corrupción</h1>
                            <p class="lead">En el marco de la lucha contra la corrupción, SERPAR LIMA viene implementando mecanismos para regular el trámite de denuncias por presuntos actos de corrupción, conforme a lo dispuesto en el Decreto Legislativo N° 1327, su reglamento, modificatorias y la Directiva N° 006-2020/SG/SERPAR LIMA/MML.</p>

                            <a href="#comenzar" v-smooth-scroll="{ duration: 1000, offset: -5 }" class="btn solid-btn d-none">Comenzar</a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5">
                        <div class="hero-animation-img">
                            <img class="img-fluid d-block m-auto animation-one" :src="'./static/img/denuncia2.png'" alt="animation image">
                        </div>
                    </div>
                </div>
            </div>
            <!--shape image start-->
            <!--<img :src="'./static/img/hero.svg'" class="shape-image" alt="shape image">-->
            <!--shape image end-->
        </section>
        <!--hero section end-->

        <!--generate denuncia start-->
        <section id="comenzar" class="feature-section mb-100 background-shape-img">
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <div class="col-md-8">
                        <div class="feature-contents section-heading">
                            <h2 class="mb-4">Realiza tu denuncia aquí</h2>
                            <div class="feature-content-wrap">
                                <ul class="nav nav-tabs feature-tab" data-tabs="tabs">
                                    <li class="nav-item">
                                        <a class="nav-link h6 active" href="#tab6-1" data-toggle="tab">
                                            <span class="el-icon-document"></span>
                                            Base Legal
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link h6" href="#tab6-2" data-toggle="tab">
                                            <span class="el-icon-finished"></span>
                                            Requisitos
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link h6" href="#tab6-3" data-toggle="tab">
                                            <span class="el-icon-document-copy"></span>
                                            Formatos
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link h6" href="#tab6-4" data-toggle="tab">
                                            <span class="el-icon-edit-outline"></span>
                                            Registro de denuncia
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content feature-tab-content">
                                    <div class="tab-pane active" id="tab6-1">
                                        <div class="single-feature">
                                            <div class="d-flex align-items-center mb-2">
                                                <span class="ti-layers rounded mr-3 icon el-icon-download bg-warning"></span>
                                                <el-link type="warning" href="https://www.serpar.gob.pe/wp-content/uploads/2020/11/DECRETO_LEGISLATIVO_N_1327.pdf" target="_blank" plain>Decreto Legislativo N.° 1327</el-link>
                                            </div>
                                        </div>
                                        <div class="single-feature">
                                            <div class="d-flex align-items-center mb-2">
                                                <span class="ti-alarm-clock rounded mr-3 icon el-icon-download bg-warning"></span>
                                                <el-link type="warning" href="https://www.serpar.gob.pe/wp-content/uploads/2020/11/REGLAMENTO_DEL_DECRETO_LEGISLATIVO_1327.pdf" target="_blank" plain>Reglamento del D. L. N.° 1327</el-link>
                                            </div>
                                        </div>
                                        <div class="single-feature">
                                            <div class="d-flex align-items-center mb-2">
                                                <span class="ti-alarm-clock rounded mr-3 icon el-icon-download bg-warning"></span>
                                                <el-link type="warning" href="https://www.serpar.gob.pe/wp-content/uploads/2020/11/RSG-N-094-2020-SG.pdf" target="_blank" plain>Directiva N° 006-2020/SG/SERPAR LIMA/MML</el-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="tab6-2">
                                        <p>Antes de formular su denuncia ante SERPAR, debe de tener en cuenta los siguientes requisitos: </p>
                                        <div class="theclass justify">
                                            <ol type="a">
                                                <li>Nombres y apellidos completos, DNI, domicilio y número telefónico del denunciante. Si el denunciante es una persona jurídica, además de la razón social, deberá consignarse el número del Registro Único de Contribuyentes (RUC) y los datos de quien la representa (Gerente General, Representante Legal u otro), señalando el número de su DNI.</li>
                                                <li>Los hechos planteados en la denuncia deben redactarse de forma detallada y coherente, precisando el periodo de tiempo en que se desarrollaron los hechos denunciados, incluyendo la identificación de los presuntos autores (nombres y apellidos y/o cargo que ocupa y/o la unidad o dependencia a la que pertenece).</li>
                                                <li>Precisar si la denuncia ha sido presentada ante otra instancia y en qué fecha.</li>
                                                <li>Lugar, fecha, firma, o huella digital en caso de no poder firmar o estar impedido de hacerlo</li>
                                                <li>A la denuncia podrá acompañarse documentación, original o copia fotostática simple, que le dé sustento. De no contar con documentación necesaria que justifique la denuncia por presunto acto de corrupción, se deberá indicar la unidad o dependencia que cuente con la misma, a efectos que se incorpore en el legajo de la denuncia.</li>
                                                <li>Compromiso del denunciante para permanecer a disposición del SERPAR, a fin de brindar las aclaraciones que hagan falta o proveer más información sobre las irregularidades motivo de la denuncia. </li>
                                            </ol>
                                            <p><span class="text-warning" style="font-weight: bold;">Nota:</span><br> De realizar la denuncia de manera anónima, no serán requisitos necesarios el literal a) y d).</p>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="tab6-3">
                                        <p>Para denunciar presuntos actos de corrupción, SERPAR facilita 2 formatos que contienen lo siguiente:</p>
                                        <div class="row">
                                            <div class="col single-feature mb-4">
                                                <div class="d-flex align-items-center mb-2">
                                                    <span class="ti-bar-chart rounded mr-3 icon el-icon-download bg-warning"></span>
                                                    <h5 class="mb-0"><a href="./static/formatos/anexo1.docx" target="_blank">Formato 1</a></h5>
                                                </div>
                                                <p>Contiene los requisitos solicitados al denunciante.</p>
                                                <el-link type="warning" href="./static/formatos/anexo1.docx" target="_blank" plain>Descargar</el-link>
                                            </div>
                                            <div class="col single-feature mb-4">
                                                <div class="d-flex align-items-center mb-2">
                                                    <span class="ti-stats-up rounded mr-3 icon el-icon-download bg-warning"></span>
                                                    <h5 class="mb-0"><a href="./static/formatos/anexo2.docx" target="_blank">Formato 2</a></h5>
                                                </div>
                                                <p>Contiene la solicitud de medida de protección, opcional para aquellos denunciantes que lo requieran.</p>
                                                <el-link type="warning" href="./static/formatos/anexo2.docx" target="_blank" plain>Descargar</el-link>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="tab-pane" id="tab6-4">
                                        <p>Para proceder con tu registro de denuncia, deberas ingresar un correo electrónico, adjuntar los formatos 1 y 2 y demás archivos que ayuden en tu denuncia.</p>
                                        <div class="row">
                                            <div class="col-sm-8 col-12">
                                                <label><b>Ingresar correo electrónico<span class="text-danger">(es necesario para notificarlo)*</span></b></label>
                                                <div class="form-group has-error">
                                                    <input type="email" class="form-control" v-model="correo" name="email" id="email" placeholder="Tu correo electrónico aquí" required="required">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-8 col-12">
                                                <el-upload class="upload-demo" ref="upload" name="file" action="https://escuelasvirtuales.serpar.gob.pe/uploadFile" :data="midata" :auto-upload="true" multiple :limit="6" :on-exceed="handleExceed" :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemove">
                                                    <el-button slot="trigger" type="primary">Adjuntar archivos a la denuncia</el-button>
                                                    <el-button class="d-none" style="margin-left: 10px;" type="success" @click="submitUpload">Subir archivos</el-button>
                                                    <div slot="tip" class="el-upload__tip"> (archivos permitidos: JPG, JPEG, PNG, DOC, DOCX, PDF) con un tamaño menor de 5Mb por cada archivo</div>
                                                </el-upload>
                                            </div>
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col-sm-12 my-3">
                                                <el-button type="warning" icon="el-icon-upload" @click="saveDenuncia" v-loading.fullscreen.lock="fullscreenLoading">Registrar denuncia</el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
        </section>
        <!--generate section end-->

    </div>
</div>
</template>

<script>
export default {
    name: 'Home',
    /*components: {
        vueDropzone: vue2Dropzone
    },*/
    data() {
        return {
            correo: null,
            midata: {
                email: ''
            },
            files: [],
            fullscreenLoading: false
        }
    },
    methods: {
        submitUpload() {
            this.midata.email = this.correo;
            this.$refs.upload.submit();
        },
        handleRemove(res, fileList) {
            console.log(res, fileList);
            console.log(res.response.idfile);
            let index = 0;
            this.files.forEach(element => {
              if(element.idfile == res.response.idfile){
                  this.files.splice(index,1);
                  index -=1;
              }
              index +=1;
            });
            console.log(this.files);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`El límite es 6 archivos, haz seleccionado ${files.length} archivos esta vez`);
        },
        handleSuccess(res, fileList) {
            if (res.status == 'success') {
                let mFile = {
                    idfile: res.idfile
                };
                this.files.push(mFile);
            }
        },
        saveDenuncia() {
            if (this.correo == null || this.correo.length <= 0) {
                this.$message.error(`Estimado usuario, tiene que ingresar un correo electrónico para poder notificarlo una vez ingresada su denuncia.`);
                return;
            }
            if (this.files.length <= 0) {
                this.$message.error(`Estimado usuario, tiene que adjuntar archivos que servirán como medios probatorios para su denuncia.`);
                return;
            }

            if (this.correo != null && this.correo.length > 0 && this.files.length > 0) {
                this.fullscreenLoading = true;
                let sfiles = '';
                this.files.forEach(element => {
                    sfiles += element.idfile + ',';
                });
                sfiles = sfiles.slice(0, -1);

                var formdata = new FormData();
                formdata.append("email", this.correo);
                formdata.append("sfiles", sfiles);

                axios.post('https://escuelasvirtuales.serpar.gob.pe/savedenuncia', formdata).then(response => {
                    this.fullscreenLoading = false;
                    if (response.data.status == 'success') {
                        this.correo = '';
                        this.$refs.upload.clearFiles();
                        this.$alert(response.data.message, response.data.title, {
                            confirmButtonText: 'Entendido',
                            type: 'success',
                            center: true,
                            callback: action => { }
                        });
                    }
                });
            }
        },
        handleError(files, fileList) {
            console.log(files);
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue